//import Vue from 'vue/dist/vue.js';

window.IC = new Vue({
    el: '.item-calcParams',
    delimiters: ['${', '}'],
    data: {
        adults: {
            count: 1,
            price: 30,
        },
        children: {
            count: 0,
            price: 0,
        },
        max: 5,
        total: 60,
    },
    mounted: function () {
        this.children.price = $('.item-calcParams').attr('children');
        this.adults.price = $('.item-calcParams').attr('adults');
    },
    computed:  {
        Total: function () {
            this.total = (this.adults.count*this.adults.price) + (this.children.count*this.children.price);
        }
    },
    methods: {
        changeForm: function() {
            аrrFields = FB.set;
            аrrFields.reduce((indexes, obj, index) => {
                if (obj.code === "adult") {
                    FB.addAdult(this.adults.count)
                }
                if (obj.code === "children") {
                    FB.addChildren(this.children.count)
                }
            }, []);
        },
        changeCount: function (people, operator) {
            var count = people == 'children' ? this.children.count : this.adults.count;

            if (operator == 'plus') {
                count = count + 1;
                count = (count <= this.max) ? count : this.max;
            } else {
                (count - 1 > 0) ? count = count - 1 : count = 0;
            }
            if (people == 'children') {
                this.children.count = count;
            } else {
                this.adults.count = count == 0 ? 1 : count;
            }
        
            IR.children.count = this.children.count;
            MC.children.count = this.children.count;
            MC.adults.count = this.adults.count;
            IR.adults.count = this.adults.count;
            this.changeForm();
        },
    },
});

window.IR = new Vue({
    el: '.item-rightCalc',
    delimiters: ['${', '}'],
    data: {
        adults: {
            count: 1,
            price: 30,
        },
        children: {
            count: 0,
            price: 30,
        },
        total: 60,
    },
    mounted: function () {
        this.children.price = $('.item-calcParams').attr('children');
        this.adults.price = $('.item-calcParams').attr('adults');
    },
    watch: {

    },
    computed:  {
        Total: function () {
            this.total = (this.adults.count*this.adults.price) + (this.children.count*this.children.price);
        }
    },
});

window.MC = new Vue({
    el: '#fastCaclulate-modal',
    delimiters: ['${', '}'],
    data: {
        adults: {
            count: 1,
            price: 30,
        },
        children: {
            count: 0,
            price: 30,
        },
        total: 60,
    },
    mounted: function () {
        this.children.price = $('.item-calcParams').attr('children');
        this.adults.price = $('.item-calcParams').attr('adults');
    },
    watch: {

    },
    computed:  {
        Total: function () {
            this.total = (this.adults.count*this.adults.price) + (this.children.count*this.children.price);
        }
    },
});

$('#item-photoSlider').lightSlider({
    gallery:true,
    vertical:true,
    item:1,
    controls: false,
    verticalHeight:578,
    vThumbWidth:230,
    thumbItem:3,
    thumbMargin:5,
    loop:true,
    enableDrag: false,
    currentPagerPosition:'left',
    easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
    speed: 600,
    pause: 3000,
    auto: false,
    slideMargin: 30,
    slideEndAnimation: true,
 
    responsive : [
        {
            breakpoint:1400,
            settings: {
                verticalHeight:500,
                vThumbWidth:222,
            }
        },
        {
            breakpoint:1300,
            settings: {
                verticalHeight:400,
                vThumbWidth:180,
            }
        },
        {
            breakpoint:1200,
            settings: {
                vertical: false,
                controls: true,
                thumbItem:0,
                pager: false,
                enableDrag: true,
                loop: true,
                galleryMargin: 30,
            }

        },
        {
            breakpoint:426,
            settings: {
                vertical: false,
                controls: true,
                thumbItem:0,
                pager: false,
                height: 200,
                verticalHeight:300,
                enableDrag: true,
                loop: false,
                galleryMargin: 30,
            }

        },
    ],
    onSliderLoad: function(el) {
        var w = $(window).width();
        if (w < 992) {
            $('.lSSlideWrapper').css('overflow', 'initial');
            $('.lSSlideOuter').css('overflow', 'initial');
            var maxHeight = 0,
                container = $(el),
                children = container.children();

            children.each(function () {
                var childHeight = $(this).height();
                if (childHeight > maxHeight) {
                    maxHeight = childHeight;
                }
            });
            container.height(maxHeight);
        }
        el.lightGallery({
            selector: '#item-photoSlider .lslide',
            download: false
        });
    }
});

$(document).ready(function () {
    fixedElement();
    startingShowCalc(10000,5000);
});

function startingShowCalc(delay_show, delay_hide) {
    if ($("div").is('.item-fastCalcWrap')) {
        let timer = setTimeout(function() {
            showCalc();
            hideCalc(delay_hide);
        }, delay_show);
        $('.item-fastCalc').on('click', function() {
            window.clearTimeout(timer);
        });
    }
    return true;
}

function hideCalc(delay) {
    if (delay === undefined) {
        $('.item-fastCalcWrap').removeClass('active',199);
    } else {
        setTimeout(function() {
            $('.item-fastCalcWrap').removeClass('active',199);
        }, delay);
    }
}

$(document).mouseup(function (e){
    if ($("div").is('.item-fastCalcWrap.active')) {
        var div = $(".item-fastCalcWrap.active");
        if (!div.is(e.target) && div.has(e.target).length === 0) {
            hideCalc();
        }
    }
});


function showCalc() {
    if ($("div").is('.item-fastCalcWrap')) {
        $('.item-fastCalcWrap').toggleClass('active',199);
    }
    return true;
}

$(window).scroll(function () {
    fixedElement();
});

$('.item-fastCalc').on('swipe', function() {
    showCalc();
    hideCalc(5000);
});

$('.item-fastCalc').on('click', function(){
    showCalc();
    hideCalc(5000);
});


$('.item-place h3').on('click', function () {
    changeShowBlock(this)
});

function changeShowBlock(block) {
    $(block).children('i').toggleClass('active')
    $(block).parent().toggleClass('active')
}



function fixedElement() {
    if ($("div").is('.item-rightCalc')) {
        element =  $('.item-rightCalc');
        var st = $(window).scrollTop();
        var w = $(window).width();
        show_start = element.offset().top + element.innerHeight() - st - 80;
        show_end = element.offset().top- st - 80;

        if ( show_start <= 0 ) {
            $('.shortCalc-top').addClass('active');
        } else {
            $('.shortCalc-top').removeClass('active');
        }
    }
    return true;
}


$('.item-right a').on('click', function (e) {
    if ($(this).attr('href').charAt(0) == '#') {
        e.preventDefault();
        var w = $(window).width();
        var  id = $(this).attr('href'),
            top = $(id).offset().top-150;
        if (w < 1200) {
            top = top+20;
        }
        $('body,html').animate({scrollTop: top}, 1500);

    }
});

